import { CITIES, STATES, COUNTRIES } from "../types";

const initialState = {
    states: [],
    cities: [],
    countries: [],
};

export default function statesCitiesReducer(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case STATES:
            return {
                ...state,
                states: payload,
            };
        case CITIES:
            return {
                ...state,
                cities: payload,
            };
        case COUNTRIES:
            return {
                ...state,
                countries: payload,
            };
        default:
            return {
                ...state,
            };
    }
}
